import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";
import Dropzone from 'react-dropzone-uploader';


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";


import {
  getJob_Advertisement_SubCategory as onGetJob_Advertisement_SubCategory,
  addJob_Advertisement_SubCategory as onAddJob_Advertisement_SubCategory,
  updateJob_Advertisement_SubCategory as onUpdateJob_Advertisement_SubCategory,
  deleteJob_Advertisement_SubCategory as onDeleteJob_Advertisement_SubCategory,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Danışman Listesi | Danışmana Sor ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');

    const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body }
  }

    const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


    const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      Doctor_NameSurname: (contactEdit && contactEdit.Doctor_NameSurname) || "",
      Doctor_Experience: (contactEdit && contactEdit.Doctor_Experience) || "",
      Doctor_About_Text: (contactEdit && contactEdit.Doctor_About_Text) || "",
      Doctor_Workplace: (contactEdit && contactEdit.Doctor_Workplace) || "",
      IsEditMobile : (contactEdit && contactEdit.IsEditMobile) || "",
      BankHolderName : (contactEdit && contactEdit.BankHolderName) || "",
      Iban : (contactEdit && contactEdit.Iban) || "",
      Commission : (contactEdit && contactEdit.Commission) || "",

     // Doctor_CaresforPeople: (contactEdit && contactEdit.Doctor_CaresforPeople) || "",
    },
    validationSchema: Yup.object({
      Doctor_NameSurname: Yup.string(3).required("Başlığı Giriniz"),


    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Doctor_NameSurname: values.Doctor_NameSurname,
          Doctor_Experience:values.Doctor_Experience.toString(),
          Doctor_About_Text:values.Doctor_About_Text,
          Doctor_Workplace:values.Doctor_Workplace,
         // Doctor_CaresforPeople: values.Doctor_CaresforPeople,
          Doctors_Category_ID: parseInt(getCategoryID),
          Users_ID : parseInt(getUsersID),
          Doctor_Picture: getFileName,
          BankHolderName:values.BankHolderName,
          Iban:values.Iban,
          Commission:values.Commission,
          IsEditMobile: getFileName !== contactEdit.Doctor_Picture ? false : contactEdit.IsEditMobile,
        };
        dispatch(onUpdateJob_Advertisement_SubCategory(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {

        const newUser = {
          Doctor_NameSurname: values["Doctor_NameSurname"],
          Doctor_Picture:getFileName,
          Doctor_Experience:values["Doctor_Experience"].toString(),
          Doctor_About_Text:values["Doctor_About_Text"],
          Doctor_Workplace:values["Doctor_Workplace"],
         // Doctor_CaresforPeople: values["Doctor_CaresforPeople"],
          Doctors_Category_ID: parseInt(getCategoryID),
          Users_ID : parseInt(getUsersID),
           BankHolderName:values["BankHolderName"],
          Iban:values["Iban"],
          Commission:values["Commission"],
           IsEditMobile:false
        };
        console.log("1231231",newUser)
        // save new user
        dispatch(onAddJob_Advertisement_SubCategory(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.jobadvertisementsubcategory,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);
  const [getCategory, setCategory] = useState([]);

  const [getUsersID, setUsersID] = useState(null);
  const [getUsers, setUsers] = useState([]);


  

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
     
         {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Doctor_Picture ? (
              <div className="avatar-xs">
                {cellProps.Doctor_NameSurname != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Doctor_NameSurname.charAt(0)}
                </span> : null}
              </div>
            ) : (
         cellProps.IsEditMobile == false ? 
               <div>
                <img
                  className="rounded-circle avatar-xl"
                  src={'https://megasubdomain.stechomeyazilim.info/' + cellProps.Doctor_Picture}
                  alt=""
                />
              </div> :
              <div>
                <img
                  className="rounded-circle avatar-xl"
                  src={'https://kontimderadmin.stechomeyazilim.com/Uploads/' + cellProps.Doctor_Picture}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },

      {
        Header: "Danışman İsmi",
        accessor: "Doctor_NameSurname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
  

        {
        Header: "Danışman Deneyimi",
        accessor: "Doctor_Experience",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

        {
        Header: "Danışman Kategorisi",
        accessor: "Doctors_Category.Doctors_Category_Text",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

        
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  const _getAuthData = async () => {

    await axios.get(`https://drrandevuadmin.stechomeyazilim.info:4435/getDoctorsCategoryList/select/`)
      .then((res) => {
        setCategory(res.data)
      })

   
  }

    const _getUsersData = async () => {

    await axios.get(`https://drrandevuadmin.stechomeyazilim.info:4435/getUsersRehber/select/`)
      .then((res) => {
        setUsers(res.data)
      })

  }
   useEffect(() => {
    _getAuthData();
  }, []);

  // Kullanıcı verisi çek
  useEffect(() => {
    _getUsersData();
  }, []);


  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetJob_Advertisement_SubCategory());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };

  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

 
    setCategoryID(user.Doctors_Category_ID)
    setFileName(user.Doctor_Picture)
    setUsersID(user.Users_ID)
    setIsEdit(true);


    toggle();
  };


  

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteJob_Advertisement_SubCategory(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const _setChoiceUsers = arg => {
    setUsersID(arg.target.value)
  }
 

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Danışmanlar Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddSubCat={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

             

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Danışman Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                          <div className="mb-3">
                              <Label className="form-label"> Kategorisi Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Doctors_Category_Text}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>


                          <div className="mb-3">
                              <Label className="form-label">Kullanıcı Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getUsersID}
                                onChange={(text) => _setChoiceUsers(text)}
                                value={
                                  getUsersID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getUsers.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Customer_NameSurname}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>
                  
                         <div className="mb-3">
  <Label className="form-label">Danışman Adı Soyadı</Label>
  <Input
    name="Doctor_NameSurname"
    label="Doctor_NameSurname"
    type="text"
    placeholder="Danışman Adını ve Soyadını Giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.Doctor_NameSurname || ""}
    invalid={
      validation.touched.Doctor_NameSurname && validation.errors.Doctor_NameSurname
        ? true
        : false
    }
  />
  {validation.touched.Doctor_NameSurname && validation.errors.Doctor_NameSurname ? (
    <FormFeedback type="invalid">
      {validation.errors.Doctor_NameSurname}
    </FormFeedback>
  ) : null}
</div>

<div className="mb-3">
  <Label className="form-label">Danışman Deneyimi (Yıl)</Label>
  <Input
    name="Doctor_Experience"
    label="Doctor_Experience"
    type="number" // Use type="number"
    placeholder="Danışman Deneyim Süresini Giriniz (Yıl)"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.Doctor_Experience || ""}
    invalid={
      validation.touched.Doctor_Experience && validation.errors.Doctor_Experience
        ? true
        : false
    }
  />
  {validation.touched.Doctor_Experience && validation.errors.Doctor_Experience ? (
    <FormFeedback type="invalid">
      {validation.errors.Doctor_Experience}
    </FormFeedback>
  ) : null}
</div>

<div className="mb-3">
  <Label className="form-label">Iban</Label>
  <Input
    name="Iban"
    label="Iban"
    type="text" // Use type="number"
    placeholder="Iban Giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.Iban || ""}
    invalid={
      validation.touched.Iban && validation.errors.Doctor_Experience
        ? true
        : false
    }
  />
  {validation.touched.Iban && validation.errors.Iban ? (
    <FormFeedback type="invalid">
      {validation.errors.Iban}
    </FormFeedback>
  ) : null}
</div>


<div className="mb-3">
  <Label className="form-label">Banka Hesap Sahibi</Label>
  <Input
    name="BankHolderName"
    label="BankHolderName"
    type="text" // Use type="number"
    placeholder="Banka Hesap Sahibinin Adını Giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.BankHolderName || ""}
    invalid={
      validation.touched.BankHolderName && validation.errors.Doctor_Experience
        ? true
        : false
    }
  />
  {validation.touched.BankHolderName && validation.errors.BankHolderName ? (
    <FormFeedback type="invalid">
      {validation.errors.BankHolderName}
    </FormFeedback>
  ) : null}
</div>


<div className="mb-3">
  <Label className="form-label">Komisyon</Label>
  <Input
    name="Commission"
    label="Commission"
    type="number" // Use type="number"
    placeholder="Komisyon Oranı Yüzde Olarak"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.Commission || ""}
    invalid={
      validation.touched.Commission && validation.errors.Commission
        ? true
        : false
    }
  />
  {validation.touched.Commission && validation.errors.Commission ? (
    <FormFeedback type="invalid">
      {validation.errors.Commission}
    </FormFeedback>
  ) : null}
</div>

<div className="mb-3">
  <Label className="form-label">Danışman Hakkında</Label>
  <Input
    name="Doctor_About_Text"
    label="Doctor_About_Text"
    type="textarea" // Use type="textarea" for multiline input
    rows="5" // Suggests a height of 5 lines
    placeholder="Danışman hakkında detaylı bilgi giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.Doctor_About_Text || ""}
    invalid={
      validation.touched.Doctor_About_Text && validation.errors.Doctor_About_Text
        ? true
        : false
    }
  />
  {validation.touched.Doctor_About_Text && validation.errors.Doctor_About_Text ? (
    <FormFeedback type="invalid">
      {validation.errors.Doctor_About_Text}
    </FormFeedback>
  ) : null}
</div>

<div className="mb-3">
  <Label className="form-label">Çalışma Alanını Giriniz</Label>
  <Input
    name="Doctor_Workplace"
    label="Doctor_Workplace"
    type="text"
    placeholder="Danışman Çalışma Alanını Giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.Doctor_Workplace || ""}
    invalid={
      validation.touched.Doctor_Workplace && validation.errors.Doctor_Workplace
        ? true
        : false
    }
  />
  {validation.touched.Doctor_Workplace && validation.errors.Doctor_Workplace ? (
    <FormFeedback type="invalid">
      {validation.errors.Doctor_Workplace}
    </FormFeedback>
  ) : null}
</div>


   <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />

                              </Col>
                            </div>
                           { getFileName != null ? 
                                 <div >
                              <img src={'https://megasubdomain.stechomeyazilim.info/' + getFileName} alt="" className="avatar-xl" />
                            </div> : null}
                            {/* 
<div className="mb-3">

  <Input
    name="Doctor_CaresforPeople"
    label="Doctor_CaresforPeople"
    type="text" // Or a dropdown with 'Evet'/'Hayır' options
    placeholder="Evet/Hayır (true/false)"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.Doctor_CaresforPeople || ""}
    invalid={
      validation.touched.Doctor_CaresforPeople && validation.errors.Doctor_CaresforPeople
        ? true
        : false
    }
  />
  {validation.touched.Doctor_CaresforPeople && validation.errors.Doctor_CaresforPeople ? (
    <FormFeedback type="invalid">
      {validation.errors.Doctor_CaresforPeople}
    </FormFeedback>
  ) : null}
  {/* If using a checkbox/switch, it would look more like this: */}
  {/* <input 
        type="checkbox" 
        name="Doctor_CaresforPeople" 
        checked={validation.values.Doctor_CaresforPeople} 
        onChange={validation.handleChange} 
    /> 
</div>*/}
                            
                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
